exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.5.3@core-js/library/modules/_object-gops.js
// module id = 120
// module chunks = 0 1